import React, { useState } from "react";
import { useStaticQuery, graphql } from "gatsby";
import Link from "gatsby-plugin-transition-link";
import { StaticImage } from "gatsby-plugin-image";

import { mapEdgesToNodes } from "../../lib/helpers";
import ModalContact from "../Modal/ModalContact";
import nestLogo from "../../images/global/NEST.svg";
import ButtonGhost from "../Button/ButtonGhost";

const Footer = ({ hideFooter }) => {
  const getYear = () => {
    return new Date().getFullYear();
  };

  const [appsDropdownOpen, setappsDropdownOpen] = useState(false);

  const appsClickHandler = () => {
    setappsDropdownOpen(!appsDropdownOpen);
  };

  const data = useStaticQuery(graphql`
    {
      apps: allSanityApps(sort: { fields: [title], order: ASC }) {
        edges {
          node {
            title
            slug {
              current
            }
          }
        }
      }
    }
  `);

  const appsNodes = data && data.apps && mapEdgesToNodes(data.apps);

  const navigation = {
    product: [
      {
        name: "How It Works",
        href: "/how-it-works/",
      },
      {
        name: "Features",
        href: "/like-zapier-real-estate-agents/",
      },
      {
        name: "Reviews",
        href: "/reviews/",
      },
      {
        name: "Pricing",
        href: "/pricing/",
      },
      {
        name: "Business Inteligence Platform",
        href: "/product/business-intelligence/",
      },
    ],
    pricing: [
      {
        name: "System Integrations",
        href: "/real-estate-software-integrations/",
      },
      // {
      //   name: "Become a Partner",
      //   href: "/pricing/",
      // },
    ],
    resources: [
      {
        name: "Blog",
        href: "/blog/",
      },
      // {
      //   name: "FAQs",
      //   href: "/blog/",
      // },
      // {
      //   name: "Support",
      //   href: "/blog/",
      // },
    ],
    testimonials: [
      {
        name: "Client Reviews",
        href: "/reviews/",
      },
      {
        name: "Success Stories",
        href: "/case/",
      },
    ],
  };

  return (
    <>
      <footer
        className={`relative z-20 bg-[#000033] pt-20 pb-12 text-center md:pt-16 md:pb-3 md:text-left ${
          hideFooter && "hidden"
        }`}
      >
        <div className="container mx-auto max-w-[1272px]">
          <div className="mb-10 grid space-y-10 md:mb-12 md:grid-cols-12 md:justify-between md:space-y-0 md:space-x-16 xl:space-x-24">
            <div className="md:col-span-4 md:col-start-1">
              <Link to="/">
                <StaticImage
                  src="../../images/global/Logo-White.svg"
                  alt="Realsynch Logo"
                  placeholder="none"
                  width={230}
                  height={48}
                  className="w-[190px] md:w-[230px]"
                />
              </Link>

              <div className="order-1 mt-10 flex items-center justify-center space-x-6 md:order-2 md:justify-start">
                <a
                  href="https://www.facebook.com/realsynch"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="texttras bg-brand-gradient bg-clip-text no-underline hover:text-primary-700/60"
                >
                  <i className="fab fa-facebook-f text-2xl"></i>
                </a>
                <a
                  href="https://www.instagram.com/realsynch1/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-brand-gradient bg-clip-text text-transparent no-underline hover:text-primary-700/60"
                >
                  <i className="fab fa-instagram text-2xl"></i>
                </a>
                <a
                  href="https://www.linkedin.com/company/realsynch"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-brand-gradient bg-clip-text text-transparent no-underline hover:text-primary-700/60"
                >
                  <i className="fab fa-linkedin text-2xl"></i>
                </a>
                <a
                  href="https://twitter.com/SynchReal"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-brand-gradient bg-clip-text text-transparent no-underline hover:text-primary-700/60"
                >
                  <i className="fab fa-twitter text-2xl"></i>
                </a>
                <a
                  href="https://www.youtube.com/channel/UCBP48w99Ws-7yCUcZ4JcFOA"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-brand-gradient bg-clip-text text-transparent no-underline hover:text-primary-700/60"
                >
                  <i className="fab fa-youtube text-2xl"></i>
                </a>
              </div>
              <div className="mt-10 ">
                <ButtonGhost
                  href="https://app.realsynch.com/login"
                  outboundLink={true}
                  text="Legacy Clients"
                  className="w-fit md:w-auto"
                />
              </div>
            </div>

            <div className="md:col-span-8 md:col-end-13">
              <div className="grid justify-center gap-y-10 md:flex md:grid-cols-2 md:justify-end md:gap-y-0 md:space-x-16 lg:space-x-32">
                <div>
                  <div className="mb-3 font-semibold text-white">Product</div>

                  <ul className="flex flex-col space-y-2">
                    {navigation.product.map((item) => (
                      <li key={item.name} className="whitespace-nowrap">
                        <Link
                          to={item.href}
                          className="text-sm font-normal text-white no-underline hover:text-primary-700"
                        >
                          {item.name}
                        </Link>
                      </li>
                    ))}
                    {/* <li className="whitespace-nowrap">
                      <a
                        href="https://cbx.realsynch.com/cbx-page"
                        target="_blank"
                        rel="noreferrer"
                        className="text-sm font-normal text-white no-underline hover:text-primary-700"
                      >
                        CBX
                      </a>
                    </li> */}
                  </ul>
                </div>

                <div>
                  <div className="mb-3 font-semibold text-white">Pricing</div>

                  <ul className="flex flex-col space-y-2">
                    {navigation.pricing.map((item) => (
                      <li key={item.name} className="whitespace-nowrap">
                        <Link
                          to={item.href}
                          className="text-sm font-normal text-white no-underline hover:text-primary-700"
                        >
                          {item.name}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>

                <div>
                  <div className="mb-3 font-semibold text-white">Resources</div>

                  <ul className="flex flex-col space-y-2">
                    {navigation.resources.map((item) => (
                      <li key={item.name} className="whitespace-nowrap">
                        <Link
                          to={item.href}
                          className="text-sm font-normal text-white no-underline hover:text-primary-700"
                        >
                          {item.name}
                        </Link>
                      </li>
                    ))}
                    <li className="whitespace-nowrap">
                      <a
                        href="https://support.realsynch.com/"
                        target="_blank"
                        rel="noreferrer"
                        className="text-sm font-normal text-white no-underline hover:text-primary-700"
                      >
                        Support
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div className="flex flex-col flex-wrap justify-items-center md:flex-row md:flex-nowrap md:items-center md:justify-between md:pt-4">
            <div className="md:flex md:items-center">
              <ul className="flex flex-wrap items-center justify-center md:justify-start md:space-x-4">
                <div className="flex w-full flex-wrap justify-center space-x-5 md:w-auto">
                  <li className="order-3 w-full font-body text-sm text-white md:order-1 md:w-auto">
                    © {getYear()} Realsynch
                  </li>

                  <li className="order-1 text-sm md:order-2">
                    <Link
                      to="/privacy-policy/"
                      className="font-body font-normal text-white no-underline hover:text-primary-700"
                    >
                      Privacy Policy
                    </Link>
                  </li>

                  <li className="order-1 text-sm md:order-2">
                    <Link
                      to="/terms/"
                      className="font-body font-normal text-white no-underline hover:text-primary-700"
                    >
                      Terms and Conditions
                    </Link>
                  </li>

                  <div className="order-2 mb-4 flex space-x-5 md:order-3 md:mb-0">
                    <li className="text-sm">
                      <button
                        className="relative font-body font-normal text-white no-underline hover:text-primary-700"
                        onClick={appsClickHandler}
                      >
                        <span className="flex items-center justify-between">
                          Featured Systems
                          <i
                            className={`far fa-chevron-down ml-1 transform text-sm transition-all duration-300 ease-linear ${
                              appsDropdownOpen ? "rotate-180" : "rotate-0"
                            }`}
                          ></i>
                        </span>
                        <ul
                          className={`absolute bottom-0 left-0 flex max-h-28 transform flex-col space-y-1.5 overflow-y-scroll bg-primary-900 px-3 pt-4 pb-3 text-left transition-all duration-300 ease-linear md:px-4 md:pb-4 md:pt-5 ${
                            appsDropdownOpen
                              ? "visible -translate-y-8 opacity-100"
                              : "invisible -translate-y-4 opacity-0"
                          }`}
                        >
                          {appsNodes.map(
                            (item, i) =>
                              item.slug && (
                                <li
                                  className="cursor-auto whitespace-nowrap pb-1.5 text-xs text-white/80"
                                  key={i}
                                >
                                  <Link
                                    to={`/${item.slug.current}/`}
                                    className="font-body font-normal text-white/80 no-underline hover:text-white"
                                  >
                                    {item.title}
                                  </Link>
                                </li>
                              )
                          )}
                        </ul>
                      </button>
                    </li>
                  </div>
                </div>
              </ul>
            </div>

            <div className="mt-10 w-full text-sm md:mt-0 md:w-auto">
              <a
                className="group flex items-center justify-center space-x-1 text-sm font-normal text-white no-underline hover:text-primary-700 md:justify-start"
                href="https://www.wisedigitalpartners.com/nest-by-wise/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={nestLogo} alt="NEST logo" />
              </a>
            </div>
          </div>
        </div>
      </footer>

      <ModalContact />
    </>
  );
};

export default Footer;
